import { _ } from "libs";

import React, { useState } from "react";
import DropdownGroup from "../dropdownFilter/dropdownGroup";
import DropdownMultiButton from "../dropdownFilter/dropdownMultiButton";
import DropdownOption from "../dropdownFilter/dropdownOption";
import DropdownRadioButton from "../dropdownFilter/dropdownRadioButton";

const defaultSport = "tennis";
const defaultCourtTypes = ["indoor", "balloon", "outdoor", "lights"];
const defaultDurations = [45, 60, 90, 120];
const defaultCourtSurfaces = ["carpet", "clay", "grass", "hard", "wood", "rebound"];
export const defaultFilter = {
	courtTypes: defaultCourtTypes,
	durations: defaultDurations,
	courtSurfaces: defaultCourtSurfaces,
	sport: defaultSport,
};
export type CourtsFilter = typeof defaultFilter;
type OnFilterChange = (filter: CourtsFilter) => void;

const CourtFilter = ({ onFilterChange, value }: { onFilterChange: OnFilterChange; value?: CourtsFilter }) => {
	const [filter, changeFilter] = useState(value);
	const onSingleFilterChange = (name: string, value: string[] | number[]) => {
		const newFilter = { ...filter, [name]: value };
		changeFilter(newFilter);
		onFilterChange(newFilter);
	};

	const onSportChange = (name: string, value: string) => {
		const newFilter = { ...filter, [name]: value };
		changeFilter(newFilter);
		onFilterChange(newFilter);
	};

	return (
		<div className="filter courtsFilter">
			<h6 className="small">{_("courts.filter.heading")}</h6>
			<DropdownGroup>
				<DropdownRadioButton
					name="sport"
					title={_("courtFilter.sport.title")}
					placeholder={_("courtFilter.sport.placeholder")}
					emptyValue={defaultSport}
					onChange={onSportChange}
					value={filter.sport}
				>
					<DropdownOption title={_("courtSport.tennis")} value={"tennis"} />
					<DropdownOption title={_("courtSport.padel")} value={"padel"} />
					<DropdownOption title={_("courtSport.badminton")} value={"badminton"} />
					<DropdownOption title={_("courtSport.squash")} value={"squash"} />
					<DropdownOption title={_("courtSport.other")} value={"other"} />
				</DropdownRadioButton>
				<DropdownMultiButton
					name="courtTypes"
					title={_("courtFilter.type.title")}
					placeholder={_("courtFilter.type.placeholder")}
					emptyValue={defaultCourtTypes}
					onChange={onSingleFilterChange}
					value={filter.courtTypes}
				>
					<DropdownOption title={_("courtType.indoor")} value={"indoor"} />
					<DropdownOption title={_("courtType.balloon")} value={"balloon"} />
					<DropdownOption title={_("courtType.outdoor")} value={"outdoor"} />
					<DropdownOption title={_("courtType.lights")} value={"lights"} />
				</DropdownMultiButton>
				<DropdownMultiButton
					name="durations"
					title={_("courtFilter.duration.title")}
					placeholder={_("courtFilter.duration.placeholder")}
					emptyValue={defaultDurations}
					onChange={onSingleFilterChange}
					value={filter.durations}
				>
					<DropdownOption title={"45 min"} value={45} />
					<DropdownOption title={"60 min"} value={60} />
					<DropdownOption title={"90 min"} value={90} />
					<DropdownOption title={"120 min"} value={120} />
				</DropdownMultiButton>
				<DropdownMultiButton
					name="courtSurfaces"
					title={_("courtFilter.surface.title")}
					placeholder={_("courtFilter.surface.placeholder")}
					emptyValue={defaultCourtSurfaces}
					onChange={onSingleFilterChange}
					value={filter.courtSurfaces}
				>
					<DropdownOption title={_("courtSurface.carpet")} value={"carpet"} />
					<DropdownOption title={_("courtSurface.clay")} value={"clay"} />
					<DropdownOption title={_("courtSurface.grass")} value={"grass"} />
					<DropdownOption title={_("courtSurface.hard")} value={"hard"} />
					<DropdownOption title={_("courtSurface.wood")} value={"wood"} />
					<DropdownOption title={_("courtSurface.rebound")} value={"rebound"} />
				</DropdownMultiButton>
			</DropdownGroup>
		</div>
	);
};

export default CourtFilter;
